/**
 * @flow
 */

/* global Sentry */

export function logBreadcrumbToSentry(data: unknown): void {
  // This is programmed defensively since we don't want attempting to log to throw a different exception
  // and hide the original exception we want reported to us in Sentry.
  if (typeof Sentry !== "undefined") {
    try {
      // If we're in an unknown state, lets send extra data to sentry.
      Sentry.addBreadcrumb({
        data,
        level: Sentry.Severity.Info,
      });
    } catch {
      // no-op
    }
  }
}

export function logErrorBreadcrumbToSentryAndRethrow(exception: Error): void {
  logBreadcrumbToSentry(exception);
  // Re-throw our original exception.
  throw exception;
}

export async function sentryTrackedFetch(requestURL: string, options: RequestOptions = {}): Promise<Response> {
  /* eslint-disable i18next/no-literal-string */
  // Add a breadcrumb BEFORE the request fires
  if (typeof Sentry !== "undefined") {
    try {
      Sentry.addBreadcrumb({
        category: "http.start",
        message: `${options.method || "GET"} ${requestURL}`,
        level: "info",
        data: {
          requestURL,
          method: options.method || "GET",
        },
      });
    } catch {
      // no-op
    }
  }

  try {
    const response = await fetch(requestURL, options);

    if (typeof Sentry !== "undefined") {
      try {
        Sentry.addBreadcrumb({
          category: "http.complete",
          message: `${response.status} ${requestURL}`,
          level: response.ok ? "info" : "warning",
          data: {
            requestURL,
            method: options.method || "GET",
            status_code: response.status,
          },
        });
      } catch {
        // no-op
      }
    }

    return response;
  } catch (error) {
    if (typeof Sentry !== "undefined") {
      try {
        Sentry.addBreadcrumb({
          category: "http.error",
          message: `FAILED ${requestURL}`,
          level: "error",
          data: {
            requestURL,
            method: options.method || "GET",
            error: error.message,
          },
        });
      } catch {
        // no-op
      }
    }
    throw error;
  }
  /* eslint-enable i18next/no-literal-string */
}
